import type { DetailsItemConfig } from '#types/config/components/order/detailsItem'
import type { RecursivePartial } from '#types/utils'

export default {
  showRewardsPaymentAfterOrderTotal: true,
} satisfies RecursivePartial<DetailsItemConfig>
